import { render, staticRenderFns } from "./ClientCardMini.vue?vue&type=template&id=39e5d78b&scoped=true&"
import script from "./ClientCardMini.vue?vue&type=script&lang=js&"
export * from "./ClientCardMini.vue?vue&type=script&lang=js&"
import style0 from "./ClientCardMini.vue?vue&type=style&index=0&id=39e5d78b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e5d78b",
  null
  
)

export default component.exports